import AscendingIcon from '../assets/icons/ascending.svg';
import DescendingIcon from '../assets/icons/descending.svg';

export const SourceOptions = [
  { label: 'Talent500', value: 'T500' },
  { label: 'Global', value: 'GLOBAL' },
];
export const SourceOptionsBooleanSearch = [
  { label: 'Talent500', value: 'T500' },
];
export const pipelineOptions = [
  {
    label: 'Active Pipeline',
    value: 'True',
  },
  {
    label: 'Inactive Pipeline',
    value: 'False',
  },
  {
    label: 'All (Active + Inactive Pipeline)',
    value: 'All',
  },
];
export const mercurialFilterOptions = [
  {
    label: 'Strongly recommended and above',
    value: 1,
  },
  {
    label: 'Recommended and above',
    value: 2,
  },
  {
    label: 'Need more info and above',
    value: 3,
  },
  {
    label: 'All',
    value: 4,
  },
];

export const SortingOptions = [
  {
    label: 'Relevance',
    value: { attr: 'relevance', order: 'asc' },
    icon: AscendingIcon,
  },
  {
    label: 'Mercurial',
    value: { attr: 'mercurial', order: 'desc' },
    icon: AscendingIcon,
  },
  {
    label: 'Last Activity Asc',
    value: { attr: 'updated_at', order: 'asc' },
    icon: AscendingIcon,
  },
  {
    label: 'Last Activity Desc',
    value: { attr: 'updated_at', order: 'desc' },
    icon: DescendingIcon,
  },
];
export const sortForLatestPDLData = [
  {
    attr: 'created_at',
    order: 'desc',
  },
  {
    attr: 'relevance',
    order: 'asc',
  },
];

export const FilterByOptions = [
  {
    label: '3 months ago',
    value: { last_contacted_on_min: null, last_contacted_on_max: 90 },
  },
  {
    label: '6 months ago',
    value: { last_contacted_on_min: null, last_contacted_on_max: 180 },
  },
  {
    label: '12 months ago',
    value: { last_contacted_on_min: null, last_contacted_on_max: 365 },
  },
];

export const selectTopProfilesOption = [
  {
    label: 'Top 50',
    value: 50,
  },
  {
    label: 'Top 100',
    value: 100,
  },
  {
    label: 'Top 200',
    value: 200,
  },
  {
    label: 'Top 400',
    value: 400,
  },
  {
    label: 'Top 500',
    value: 500,
  },
  {
    label: 'Top 1000',
    value: 1000,
  },
  {
    label: 'Top 1500',
    value: 1500,
  },
  {
    label: 'Top 2000',
    value: 2000,
  },
  {
    label: 'Top 5000',
    value: 5000,
  },
  {
    label: 'Select All (max 10000 only)',
    value: 10000,
  },
];

export const NO_DATA_T500_MESSAGE = 'No Candidate found in Talent500 Database for the applied filters. Please change filters or try searching in Global Database.';
export const NO_DATA_GLOBAL_MESSAGE = 'No Candidate found in Global Database for the applied filters. Please change filters or try searching in Talent500 Database.';
export const MAX_PAYLOAD_SIZE = 10000;
export const ERROR_MESSAGE = 'Something went wrong!';
